import { render, staticRenderFns } from "./HowToUseHachishukVoucherPopup.vue?vue&type=template&id=0641b928&scoped=true"
import script from "./HowToUseHachishukVoucherPopup.vue?vue&type=script&lang=js"
export * from "./HowToUseHachishukVoucherPopup.vue?vue&type=script&lang=js"
import style0 from "./HowToUseHachishukVoucherPopup.vue?vue&type=style&index=0&id=0641b928&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0641b928",
  null
  
)

export default component.exports